var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"vh-100",attrs:{"align-v":"center"}},[_c('b-col',{staticClass:"text-center"},[_c('h1',[_vm._v(_vm._s(_vm.$t('error_page_not_found')))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }